<template>
  <section :class="$style.container">
    <ButtonLoginSwitch
      v-if="!redirectTo && !loginChallenge"
      :clickHandler="goToUserLogin"
    >
      User Portal Login
    </ButtonLoginSwitch>
    <div :class="$style.formContainer">
      <AdminLoginForm
        :autofocus="autofocus"
        :form="form"
        :updateAutofocus="updateAutofocus"
        :goToUserLogin="goToUserLogin"
        v-bind="$props"
      />
      <LogoIcon />
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

import AdminLoginForm from 'client/containers/Login/AdminLoginForm.vue';
import ButtonLoginSwitch from 'client/components/ButtonLoginSwitch.vue';
import Constants from 'client/util/Constants';
import Cookies from 'js-cookie';
import LoginConsts from 'client/util/Constants/LoginConstants';
import LogoIcon from 'client/components/LogoIcon.vue';
import loginUtil from 'client/components/mixins/loginUtil';

const { redirectTo } = Constants;
const { clientType, clientTypeCookie } = LoginConsts;

export default {
  name: 'AdminLoginWrapper',

  mixins: [
    loginUtil,
  ],

  props: {
    clientType: {
      type: String,
      default: clientType.admin,
    },
    error: {
      type: String,
      default: undefined,
    },
    redirectTo: {
      type: String,
      default: '',
    },
    requestKey: {
      type: String,
      default: '',
    },
    form: {
      type: Object,
      default: () => ({
        email: '',
        password: '',
      }),
    },
  },

  components: {
    AdminLoginForm,
    LogoIcon,
    ButtonLoginSwitch,
  },

  methods: {
    goToUserLogin() {
      // removing redirectTo from session to prevent issues when swtiching clientTypes
      sessionStorage.removeItem(redirectTo);
      this.vueRouteChange('Login', { form: this.form });
    },
  },

  computed: {
    ...mapGetters('LoginOauthAdminFlowModel', [
      'loginChallenge',
    ]),
  },

  mounted() {
    Cookies.set(clientTypeCookie, 'admin');
  },
};
</script>

<style module>
@import '../../css/login-components.css';
</style>
